import React, { useEffect, useState } from "react";
import { ArrowLeft, Phone, Mail, Home } from "lucide-react";
import { cvApi, cvErr, fmtPhone } from "@/lib/vendorApi";

const Line = ({ label, value, testid }) => value ? <div className="flex justify-between gap-4 py-1.5 border-b border-white/5 text-sm" data-testid={testid}><span className="text-white/50">{label}</span><span className="text-right">{value}</span></div> : null;

/** One worker's profile (no health info or ID numbers). */
export function WorkerDetail({ id, onBack, onMessage }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { cvApi.get(`/residents/${id}`).then(setD).catch((e) => setErr(cvErr(e))); }, [id]);
  if (err) return <p className="text-red-300 text-sm">{err}</p>;
  if (!d) return <p className="text-white/40 text-sm">Loading…</p>;
  const emp = d.employment || {};
  return (
    <div className="space-y-4" data-testid="vendor-worker-detail">
      <button type="button" onClick={onBack} data-testid="vendor-worker-back" className="inline-flex items-center gap-1 text-sm text-white/60 hover:text-white"><ArrowLeft className="h-4 w-4" /> All workers</button>
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div><h2 className="text-2xl font-semibold">{d.name}</h2><p className="text-sm text-white/50">Phase {d.phase || "I"} · {d.status}</p></div>
        <button type="button" onClick={() => onMessage(d.id)} data-testid="vendor-worker-message" className="rounded-md bg-[#d4a017] text-black text-sm font-semibold px-4 py-2">Send a memo</button>
      </div>
      <div className="rounded-lg border border-white/10 p-4">
        <Line label="Mobile" value={fmtPhone(d.phone)} testid="vendor-worker-phone" />
        <Line label="Email" value={d.email} />
        <Line label="Date of birth" value={d.dob} />
        <Line label="Gender" value={d.gender} />
        <Line label="House" value={d.house} />
        <Line label="Room & bed" value={d.room} />
        <Line label="Moved in" value={d.move_in} />
        <Line label="Case manager" value={d.case_manager} />
        <Line label="Emergency contact" value={[d.emergency_contact, d.emergency_contact_relationship].filter(Boolean).join(" · ")} />
        <Line label="Platform ID" value={d.platform_id} />
        {Object.entries(emp).filter(([, v]) => v !== null && v !== "" && typeof v !== "object").map(([k, v]) => <Line key={k} label={k.replace(/_/g, " ")} value={v === true ? "Yes" : v === false ? "No" : String(v)} />)}
      </div>
    </div>
  );
}

export function WorkerList({ rows, onOpen }) {
  if (!rows.length) return <p className="text-white/50 text-sm" data-testid="vendor-workers-empty">No workers are assigned to you yet. Your TEA contact will add them.</p>;
  return (
    <div className="grid sm:grid-cols-2 gap-3" data-testid="vendor-workers">
      {rows.map((r) => (
        <button key={r.id} type="button" onClick={() => onOpen(r.id)} data-testid={`vendor-worker-${r.id}`}
          className="text-left rounded-lg border border-white/10 bg-white/[0.03] p-4 hover:border-[#d4a017]/60 transition-colors">
          <div className="font-semibold">{r.name}</div>
          <div className="text-xs text-white/50 mt-1 space-y-0.5">
            {r.phone && <div className="flex items-center gap-1.5"><Phone className="h-3 w-3" /> {fmtPhone(r.phone)}</div>}
            {r.email && <div className="flex items-center gap-1.5"><Mail className="h-3 w-3" /> {r.email}</div>}
            {r.house && <div className="flex items-center gap-1.5"><Home className="h-3 w-3" /> {r.house}</div>}
          </div>
        </button>
      ))}
    </div>
  );
}
